import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "download-customer-forecast-modal__main-content main-content" }
const _hoisted_2 = { class: "main-content__label" }
const _hoisted_3 = { class: "main-content__picker-container" }
const _hoisted_4 = { class: "main-content__picker-item" }
const _hoisted_5 = { class: "main-content__picker-label" }
const _hoisted_6 = { class: "main-content__picker-item" }
const _hoisted_7 = { class: "main-content__picker-label" }

import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import MonthPicker from '@/corePagesModule/components/MonthPicker.vue';
import { i18n } from '@/i18n';
import { computed, ref, watch } from 'vue';
import { IYearMonth } from '@/coreDomainsModule/date';
import { DateService } from '@/coreDomainsModule/services/dateService';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'DownloadCustomerForecastModal',
  props: {
    modalState: { type: Boolean },
    initialStartYearMonth: {},
    initialEndYearMonth: {}
  },
  emits: ["close", "apply"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

// 変数
const t = i18n.t;
const locale = computed(() => i18n.locale);

// 開始年月
const startYearMonth = ref<IYearMonth>({ year: 0, month: 0 });

// 終了年月
const endYearMonth = ref<IYearMonth>({ year: 0, month: 0 });

/**
 * モーダルが開かれた時にデフォルト値を設定
 */
watch(
  () => props.modalState,
  (newValue) => {
    if (newValue) {
      // propsで初期値が渡されている場合はそれを使用
      if (props.initialStartYearMonth && props.initialStartYearMonth.year !== 0) {
        startYearMonth.value = { ...props.initialStartYearMonth };
      } else {
        // 現在の年月をデフォルトとして設定
        const currentDate = new Date();
        startYearMonth.value = DateService.convertDateToIYearMonth(currentDate);
      }

      if (props.initialEndYearMonth && props.initialEndYearMonth.year !== 0) {
        endYearMonth.value = { ...props.initialEndYearMonth };
      } else {
        // 終了月は開始月 + 3ヶ月をデフォルトとして設定
        endYearMonth.value = DateService.getShiftedIYearMonthByMonths(startYearMonth.value.year, startYearMonth.value.month, 3);
      }
    }
  },
  { immediate: true }
);

/**
 * ダウンロードボタンの非活性状態
 */
const isDisabledApplyButton = computed(() => {
  return (
    startYearMonth.value.year === 0 || endYearMonth.value.year === 0 || startYearMonth.value.month === 0 || endYearMonth.value.month === 0
  );
});

/**
 * 開始年月選択時の処理
 * @param yearMonth - 選択された年月
 */
const onSelectedStartYearMonth = (yearMonth: IYearMonth) => {
  startYearMonth.value = yearMonth;
};

/**
 * 終了年月選択時の処理
 * @param yearMonth - 選択された年月
 */
const onSelectedEndYearMonth = (yearMonth: IYearMonth) => {
  endYearMonth.value = yearMonth;
};

/**
 * ダウンロードボタンクリック時の処理
 */
const onApply = () => {
  emits('apply', startYearMonth.value, endYearMonth.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    "modal-state": _ctx.modalState,
    "back-button-label": _unref(t)('もどる'),
    "next-button-label": _unref(t)('ダウンロード'),
    "modal-width": 500,
    "is-disabled-next-button": isDisabledApplyButton.value,
    onOnBack: _cache[2] || (_cache[2] = ($event: any) => (emits('close'))),
    onOnNext: onApply
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('客先内示ダウンロード')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('期間の選択')), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(t)('開始月')), 1),
            _createVNode(MonthPicker, {
              class: "main-content__calendar download-customer-forecast-calendar",
              "model-value": startYearMonth.value,
              locale: locale.value,
              "prop-format": 'yyyy / MM',
              "max-date": endYearMonth.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (onSelectedStartYearMonth($event)))
            }, null, 8, ["model-value", "locale", "max-date"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(t)('終了月')), 1),
            _createVNode(MonthPicker, {
              class: "main-content__calendar download-customer-forecast-calendar",
              "model-value": endYearMonth.value,
              locale: locale.value,
              "prop-format": 'yyyy / MM',
              "min-date": startYearMonth.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (onSelectedEndYearMonth($event)))
            }, null, 8, ["model-value", "locale", "min-date"])
          ])
        ])
      ])
    ], undefined, true),
    _: 1
  }, 8, ["modal-state", "back-button-label", "next-button-label", "is-disabled-next-button"]))
}
}

})